import generateCustomerToken from './generateToken';

export default generateCustomerToken;
